import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import LuggageStorageServicesPage from '@/v2/components/pages/public-pages/luggage-storage-services-page'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/public-pages/luggage-storage-services-page'

interface LuggageStorageServicesPageProps {}

const Page: React.FC<LuggageStorageServicesPageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.luggage_storage_services.title ?? ''}
        keywords={META_CONTENTS.luggage_storage_services?.keywords ?? ''}
        description={META_CONTENTS.luggage_storage_services?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <LuggageStorageServicesPage />
    </>
  )
}

export default Page
